import * as yup from "yup";
import { portugues } from "_utils/validador";

yup.setLocale(portugues);

export const ExcluirLoteSchema = yup.object().shape({
  observacao: yup.string().required("O motivo é obrigatório").min(1),
});
